import { useEffect, useState } from "react";

import { minutesNow } from "./calendarLayout";

/**
 * Minutes since midnight, re-read every minute while `active` — the calendar
 * only needs a ticking clock on the day that is actually today.
 */
export function useNowMinutes(active) {
  const [nowMinutes, setNowMinutes] = useState(minutesNow);

  useEffect(() => {
    if (!active) return undefined;
    setNowMinutes(minutesNow());
    const interval = setInterval(() => setNowMinutes(minutesNow()), 60_000);
    return () => clearInterval(interval);
  }, [active]);

  return nowMinutes;
}
